import { FC } from 'react'

import clsx from 'clsx'

import { ImageLazy } from 'shared/ui/image-lazy'

import { Button } from '../button'

import styles from './styles.module.scss'

export interface Props {
  image?: string
  title?: string
  subTitle?: string
  isBeket?: boolean
  buttonText?: string
  onClick?: () => void
}

export const EmptyPage: FC<Props> = ({
  image,
  title,
  subTitle,
  isBeket,
  buttonText,
  onClick,
}) => {
  return (
    <div className={styles.container}>
      {image && (
        <div className={clsx(styles.image, isBeket && styles.beketImage)}>
          <ImageLazy
            src={image}
            alt="empty"
          />
        </div>
      )}

      <div className={styles.content}>
        <p className={clsx(styles.title, 'bold-17')}>{title}</p>
        <span
          className={clsx(
            styles.description,
            'regular-14',
            isBeket && styles.grey,
          )}
        >
          {subTitle}
        </span>
      </div>

      {buttonText && (
        <Button
          className={styles.button}
          onClick={onClick}
        >
          <span className={clsx('semi-bold-17')}>{buttonText}</span>
        </Button>
      )}
    </div>
  )
}
